import { DocumentAddData, DocumentListApiResponse, DocumentUpdateData } from "../context/DocumentContext/constants";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	ADD: "/cms/add-document",
	REMOVE: "/cms/remove-document",
	LIST: "/cms/get-documents",
	GET: "/cms/get-document-details",
	UPDATE: "/cms/update-document",
};

export class DocumentService {
	static async addDocument(docData: DocumentAddData) {
		const formData = new FormData();

		formData.append("categoryId", docData.categoryId);

		docData.documents?.forEach((file) => {
			formData.append("documents", file);
		});

		return await axiosInstance.post(`${ENDPOINTS.ADD}`, formData);
	}

	static async removeDocument(docId: string) {
		return await axiosInstance.delete(`${ENDPOINTS.REMOVE}?docId=${docId}`);
	}

	static async getDocumentList(categoryId?: string): Promise<DocumentListApiResponse> {
		const params = categoryId ? { categoryId } : {};
		const response = await axiosInstance.get(`${ENDPOINTS.LIST}`, { params });

		return response.data;
	}

	static async getDocumentDetail(docId: string) {
		const response = await axiosInstance.get(`${ENDPOINTS.GET}?docId=${docId}`);
		return response.data;
	}

	static async updateDocument(data: DocumentUpdateData) {
		const formData = new FormData();

		formData.append("id", data.documentId);
		formData.append("documentName", data.documentName);

		return await axiosInstance.put(`${ENDPOINTS.UPDATE}`, formData);
	}
}